import React from "react";

import { Body } from "@/ui/typography/Body";

type ProductDetailsInfoAttributesEntryProps = {
  label: string;
  values?: string[];
};

export const ProductDetailsInfoAttributesEntry = ({
  label,
  values,
}: ProductDetailsInfoAttributesEntryProps) => {
  if (!values || !values.length) {
    return null;
  }

  const valuesLabel = values.join(", ");

  return (
    <>
      <Body>{label}</Body>
      <Body>{valuesLabel}</Body>
    </>
  );
};
